export enum AssetsCode {
    REQUIRED = 'REQUIRED',
    NOT_REQUIRED = 'NOT_REQUIRED',
}